import { useMutation } from '@tanstack/react-query';
import { useApi, useAuth } from '../../../hooks';
import { User } from '../../../models/user';

// The request we do to POST on the register endpoint
// has different fields about address compared to the
// original User model.
// We should probably unify them.
type RequestPayload = {
  street: string;
  city: string;
  state: string;
  zip: string;
} & User;

export const useRegisterPost = () => {
  const { api } = useApi();

  const { userToken } = useAuth();

  const nonce = Math.floor(Math.random() * 1000 * (Math.random() * 1000));

  const mutation = useMutation({
    mutationFn: (payload: Partial<RequestPayload>) => {
      return api({
        token: userToken,
        route: `/register/${nonce}`,
        method: 'POST',
        payload,
      });
    },
  });

  return {
    mutation,
  };
};

export default useRegisterPost;
